import Select from 'components/global/Select'
import PropTypes from 'prop-types'

function ListGroup({ items, activeItem, setActiveItem, mappedItems }) {
  const selectOptions = mappedItems.map((item, index) => ({
    label: item.title,
    value: index,
  }))

  return (
    <div className="flex flex-col items-stretch md:w-72">
      {/* Mobile select bar */}
      <div className="md:hidden">
        {/* This will just be titles */}
        <Select
          options={selectOptions}
          onChange={(selected) => {
            setActiveItem(items[selected.value])
          }}
        />
      </div>

      {/* Desktop selector */}
      <div className="hidden divide-y rounded-lg border md:flex md:flex-col">
        {mappedItems?.map((item, index) => {
          return (
            <button
              key={items[index].id}
              onClick={() => setActiveItem(items[index])}
              className={`${
                activeItem.id === items[index].id
                  ? 'bg-purple-800 text-white'
                  : ''
              } 
                  ${
                    index === 0
                      ? 'rounded-t-lg'
                      : index === items.length - 1
                      ? 'rounded-b-lg'
                      : ''
                  } flex flex-col items-start space-y-1 p-4 text-left text-sm transition duration-150`}
            >
              <span className="font-bold">{item.title}</span>

              <span className="opacity-50">{item.firstLine}</span>

              <span className="opacity-50">{item.secondLine}</span>

              <span className="opacity-50">{item.thirdLine}</span>
            </button>
          )
        })}
      </div>
    </div>
  )
}

ListGroup.propTypes = {
  items: PropTypes.array,
  mappedItems: PropTypes.array,
  activeItem: PropTypes.object,
  setActiveItem: PropTypes.func,
}

export default ListGroup
